import React, { type ReactElement } from 'react';
import QueryParamAdapter from '@atlassian/jira-common-query-param-adapter/src/index.tsx';
import type { Location } from '@atlassian/react-resource-router';
import { initialQuery } from './model/constants/initial-query.tsx';
import type { Query } from './model/index.tsx';
import { queryFromUrl } from './transformers/query-from-url.tsx';
import { queryToUrl } from './transformers/query-to-url.tsx';

type Props = {
	location: Location;
	children: (arg1: { query: Query; onQueryChanged: (arg1: Query) => void }) => ReactElement;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ location, children }: Props) => (
	<QueryParamAdapter
		location={location}
		queryFromUrl={queryFromUrl}
		queryToUrl={queryToUrl}
		defaultQuery={initialQuery}
	>
		{children}
	</QueryParamAdapter>
);
